import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

// 🎯 اللوجو الافتراضي للنظام ككل - متخزن كـ logo_url عادي على مؤسسة
// System Settings المحجوزة (__GLOBAL__)، بنفس آلية رفع لوجو أي مؤسسة
// عادية (/organizations/{org_id}/upload-logo) من غير أي endpoint جديد
export const GLOBAL_ORG_ID = '__GLOBAL__';

export const useSystemDefaultLogo = () => {
  const [logoUrl, setLogoUrl] = useState('');
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(() => {
    axios.get(`/api/organizations/${GLOBAL_ORG_ID}`)
      .then((res) => setLogoUrl(res.data?.logo_url || ''))
      .catch(() => setLogoUrl(''))
      .finally(() => setLoaded(true));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { logoUrl, loaded, refresh };
};

export default useSystemDefaultLogo;
